import { makeAutoObservable, action, toJS, runInAction } from "mobx";
import { makePersistable } from "mobx-persist-store";

class Store {
    activeTeamId: number
    loading: boolean
    scrollLoading: boolean
    total = 0
    searchValue: string
    searchText: string
    accountList = []
    page = 1
    isThisAgent = false
    constructor() {
        makeAutoObservable(this);
        makePersistable(this, {
            name: "AgentUser",
            properties: ["isThisAgent", 'activeTeamId'],
            storage: window.localStorage,
        });
    }
    @action setAccountList = (value) => {
        this.accountList = value
    };
    @action setActiveTeamId = (id) => {
        this.activeTeamId = id
    };
    @action setScrollLoading = (val) => {
        this.scrollLoading = val
    };
    @action setLoading = (val) => {
        this.loading = val
    };
    @action setTotal = (val) => {
        this.total = val
    };
    @action setSearchValue = (val) => {
        this.searchValue = val
    };
    @action setSearchText = (val) => {
        this.searchValue = val
    };
    setPage = (val) => {
        this.page = val
    };
    @action setIsThisAgent = (val) => {
      this.isThisAgent = val
    }

}

const AgentStore = new Store();
export default AgentStore;
